export default __webpack_public_path__ + "static/media/account.b22b572a.svg";